var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cascader',{attrs:{"data":_vm.cityList,"filterable":""},on:{"on-change":_vm.selectCity},model:{value:(_vm.cityCode),callback:function ($$v) {_vm.cityCode=$$v},expression:"cityCode"}})}
var staticRenderFns = []

export { render, staticRenderFns }